// src/utils/statusColor.js
export const STATUS_COLOR_MAP = {
  PENDING_DELIVERY: 'pending-delivery',
  PENDING_PICKUP: 'pending-pickup',
  ACTIVE: 'active',
  PENDING_COMPANY_PICKUP: 'pending-company-pickup',
  PENDING_RETURN: 'pending-return',
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled',
};

export function statusColorClass(status) {
  return STATUS_COLOR_MAP[status] || 'unknown';
}